/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedRefineMenuInputRangeDimensions_searchBrowse = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuInputRangeDimensions_searchBrowse",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRange_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedMeasurementUnitProvider_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDimensionUnitRadioSelect_searchBrowse",
      "args": null
    }
  ],
  "type": "SearchBrowseQueryConnection"
};

module.exports = fragment;
